/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Vp_Blocked_Half_VpInputs */



/**
* | output |
* | --- |
* | "Seat {seats}: Score half a point on timeout." |
*
* @param {Vp_Blocked_Half_VpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_half_vp = /** @type {((inputs: Vp_Blocked_Half_VpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_Half_VpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Placement ${i?.seats} : un demi-point est marqué à la fin du temps.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Asiento ${i?.seats}: se anota medio punto al agotarse el tiempo.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Assento ${i?.seats}: marca meio ponto quando o tempo acaba.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posto ${i?.seats}: si segna mezzo punto allo scadere del tempo.`)
	return /** @type {LocalizedString} */ (`Seat ${i?.seats}: Score half a point on timeout.`)
});